<template>
<!--  viewBox="0 0 28 28"-->
    <path d="M4 14H25" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
    <path d="M4 22H25" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
    <path d="M4 6H25" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
</template>